export default __webpack_public_path__ + "locales/sw.bua.json";